import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import type { Appointment } from '../types';

async function getAppointment(appointmentId?: string): Promise<Appointment | null> {
  if (!appointmentId) return null;

  const response = await axiosPrivate.get(`/v3/pharmacist/appointments/${appointmentId}`);
  return response.data;
}

export const appointmentQueryKey = (appointmentId?: string) => ['appointments', appointmentId];

export default function useGetAppointmentById(appointmentId?: string) {
  return useQuery({
    queryKey: appointmentQueryKey(appointmentId),
    queryFn: () => getAppointment(appointmentId),
    enabled: Boolean(appointmentId),
  });
}
